const WizardInfoBox = ({ children, className = '' }) => {
  return <div className={`comp-wizard-info-box ${className}`}>{children}</div>;
};

export default WizardInfoBox;
